import { DropdownComponent } from './dropdown.component';

export const DropdownModule = angular
  .module('sfMobile.components.dropdown', [])
  .component('sfDropdown', DropdownComponent).name;
